var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExcellent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1662 24.8325C20.0571 24.8325 24.8325 20.0571 24.8325 14.1662C24.8325 8.27543 20.0571 3.5 14.1662 3.5C8.27543 3.5 3.5 8.27543 3.5 14.1662C3.5 20.0571 8.27543 24.8325 14.1662 24.8325Z",
    fill: "url(#paint0_radial_1414_3918)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.1662 24.8325C20.0571 24.8325 24.8325 20.0571 24.8325 14.1662C24.8325 8.27543 20.0571 3.5 14.1662 3.5C8.27543 3.5 3.5 8.27543 3.5 14.1662C3.5 20.0571 8.27543 24.8325 14.1662 24.8325Z",
    fill: "url(#paint1_radial_1414_3918)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6906 7.19585C11.5914 6.77914 11.0804 6.62535 10.3065 6.80889C9.64663 6.96765 8.29227 7.67213 7.60267 9.18525C7.47369 9.46304 7.78624 9.52755 7.93009 9.3291C8.41628 8.66434 9.89468 7.60762 11.2093 7.44393C11.7402 7.37942 11.6906 7.19585 11.6906 7.19585Z",
    fill: "url(#paint2_linear_1414_3918)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6839 14.1263C11.3223 14.1263 11.8398 13.089 11.8398 11.8095C11.8398 10.5299 11.3223 9.49268 10.6839 9.49268C10.0455 9.49268 9.52795 10.5299 9.52795 11.8095C9.52795 13.089 10.0455 14.1263 10.6839 14.1263Z",
    fill: "url(#paint3_radial_1414_3918)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6837 10.277C11.1798 10.277 11.6114 10.8525 11.8346 11.6958C11.8198 10.4407 11.3088 9.43359 10.6837 9.43359C10.0536 9.43359 9.54759 10.4407 9.53271 11.6958C9.75594 10.8525 10.1876 10.277 10.6837 10.277Z",
    fill: "url(#paint4_linear_1414_3918)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3696 15.9721C21.2902 15.9423 21.2009 15.9374 21.1215 15.9622C18.8692 16.6071 16.5325 16.9296 14.1711 16.9296C11.8096 16.9296 9.46797 16.6022 7.22062 15.9622C7.13631 15.9374 7.05196 15.9423 6.97258 15.9721C6.7295 16.0713 6.34254 16.4384 6.85351 17.8424V17.8473C7.60758 19.6433 9.60689 22.7985 14.1661 22.7985C18.7154 22.7985 20.7147 19.6383 21.4886 17.8473C21.9946 16.4384 21.6126 16.0713 21.3696 15.9721Z",
    fill: "url(#paint5_radial_1414_3918)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 22.2971C16.0568 22.2971 17.4756 21.7167 18.5373 20.9229C17.3714 20.397 15.9327 20.0547 14.1666 20.0547C12.4005 20.0547 10.9617 20.402 9.7959 20.9328C10.8576 21.7167 12.2765 22.2971 14.1666 22.2971Z",
    fill: "url(#paint6_radial_1414_3918)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2256 15.9424C21.2107 15.9424 21.1958 15.9424 21.1759 15.9474C18.9038 16.6022 16.5473 16.9346 14.161 16.9346C11.7748 16.9346 9.41826 16.6022 7.14613 15.9474C7.13122 15.9424 7.11635 15.9424 7.0965 15.9424C6.94271 15.9573 6.20848 16.1111 6.83852 17.8474V17.8524C7.14613 18.5767 7.6571 19.5243 8.45583 20.3925C7.70673 19.5044 8.62947 19.0133 10.2716 19.2117C11.9137 19.4102 14.161 19.4151 14.161 19.4151C14.161 19.4151 16.4034 19.4102 18.0505 19.2117C19.6926 19.0133 20.6154 19.5044 19.8662 20.3925C20.665 19.5243 21.1759 18.5767 21.4835 17.8524V17.8474C22.1136 16.1061 21.3794 15.9523 21.2256 15.9424Z",
    fill: "url(#paint7_linear_1414_3918)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.961 18.3833C20.5861 18.2493 21.0574 17.7284 21.1169 17.0884L21.1764 16.4634C18.9042 17.1034 16.5478 17.4308 14.1665 17.4308C11.7852 17.4308 9.42866 17.1034 7.15649 16.4634L7.21603 17.0884C7.27556 17.7235 7.74687 18.2444 8.37197 18.3833C10.2671 18.795 12.2118 18.9985 14.1665 18.9985C16.1211 18.9985 18.0659 18.7901 19.961 18.3833Z",
    fill: "url(#paint8_radial_1414_3918)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.642 7.19585C16.7412 6.77914 17.2522 6.62535 18.0261 6.80889C18.6859 6.96765 20.0403 7.67213 20.7299 9.18525C20.8589 9.46304 20.5463 9.52755 20.4025 9.3291C19.9163 8.66434 18.4379 7.60762 17.1232 7.44393C16.5924 7.37942 16.642 7.19585 16.642 7.19585Z",
    fill: "url(#paint9_linear_1414_3918)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.649 14.1263C18.2874 14.1263 18.8049 13.089 18.8049 11.8095C18.8049 10.5299 18.2874 9.49268 17.649 9.49268C17.0106 9.49268 16.493 10.5299 16.493 11.8095C16.493 13.089 17.0106 14.1263 17.649 14.1263Z",
    fill: "url(#paint10_radial_1414_3918)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6487 10.277C17.1527 10.277 16.721 10.8525 16.4978 11.6958C16.5127 10.4407 17.0237 9.43359 17.6487 9.43359C18.2788 9.43359 18.7848 10.4407 18.7997 11.6958C18.5765 10.8525 18.1449 10.277 17.6487 10.277Z",
    fill: "url(#paint11_linear_1414_3918)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1414_3918",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.0676 9.84357) scale(12.8674)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB82E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1414_3918",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.0676 9.84357) scale(10.1234)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1414_3918",
    x1: 9.66875,
    y1: 8.41017,
    x2: 9.40856,
    y2: 7.31677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1414_3918",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.3347 11.8682) rotate(77.7198) scale(2.21132 1.11314)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1414_3918",
    x1: 10.6839,
    y1: 9.48049,
    x2: 10.6839,
    y2: 11.6412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1414_3918",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1661 19.3723) scale(5.87584 5.87584)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1414_3918",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.2545 21.4389) scale(4.8698 1.47214)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2479,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C10000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1414_3918",
    x1: 21.6528,
    y1: 18.1645,
    x2: 6.77023,
    y2: 18.1645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#512D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2200"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1414_3918",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1665 17.7332) scale(12.8858 12.8858)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8BBBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1414_3918",
    x1: 18.6619,
    y1: 8.40681,
    x2: 18.9221,
    y2: 7.31341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1414_3918",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.999 11.8675) rotate(102.28) scale(2.21132 1.11314)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1414_3918",
    x1: 17.6485,
    y1: 9.48053,
    x2: 17.6485,
    y2: 11.6412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcellent);
export default __webpack_public_path__ + "static/media/Excellent.b7d8583d252086d93f8bde7904858600.svg";
export { ForwardRef as ReactComponent };